import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../../i18n/I18nContext";

export default function ReturnsPolicy() {
  const { t } = useI18n();

  const sections = [
    {
      id: "dominio",
      title: "Domínio",
      content: (
        <>
          <p>
            {t(
              "Esta página foi criada por ou para a Racksforall.eu para informar o público, de forma gratuita, sobre os serviços e produtos relacionados com a marca."
            )}
          </p>
          <p>
            {t(
              "O acesso, navegação e utilização do site implica a aceitação expressa e sem reservas dos presentes termos."
            )}
          </p>
        </>
      ),
    },
    {
      id: "utilizacao-site",
      title: "Condições de Utilização do Site",
      content: (
        <>
          <p>
            {t(
              "O consumidor compromete-se a utilizar o site em conformidade com a legislação aplicável, abstendo-se de o usar para atividades contrárias à lei, aos bons costumes, à moral ou a direitos de terceiros."
            )}
          </p>
          <p>
            {t(
              "A Racksforall.eu reserva-se o direito de modificar o conteúdo, serviços e condições de utilização sem aviso prévio."
            )}
          </p>
        </>
      ),
    },
    {
      id: "protecao-dados",
      title: "Política de Proteção de Dados",
      content: (
        <>
          <p>
            {t(
              "A Racksforall.eu está dedicada a honrar a privacidade dos seus utilizadores e trata os dados em conformidade com o RGPD."
            )}
          </p>
          <p>
            {t(
              "Os dados recolhidos podem incluir nome, NIF, género, data de nascimento, contacto telefónico, morada, email e nome da empresa."
            )}
          </p>
        </>
      ),
    },
    {
      id: "precos",
      title: "Política de Preços e Produtos",
      content: (
        <>
          <p>
            {t(
              "A Racksforall.eu reserva-se ao direito de alterar os preços em qualquer momento."
            )}
          </p>
          <p>
            {t(
              "Os preços apresentados são em euros e podem não incluir IVA à taxa legal em vigor, conforme indicado no site."
            )}
          </p>
          <p>
            {t(
              "Em caso de erro notório de preço ou condições de venda, o pedido poderá ser considerado inválido e anulado."
            )}
          </p>
        </>
      ),
    },
    {
      id: "pagamento",
      title: "Métodos de Pagamento",
      content: (
        <>
          <ul className="space-y-2 text-slate-600">
            <li>{t("Referência Multibanco")}</li>
            <li>PayPal</li>
            <li>MB Way</li>
            <li>Payshop</li>
          </ul>
        </>
      ),
    },
    {
      id: "expedicao",
      title: "Expedição de Encomendas e Portes",
      content: (
        <>
          <p>
            {t(
              "A data de entrega apresentada nos produtos é uma previsão para Portugal Continental."
            )}
          </p>
          <p>
            {t(
              "As encomendas são processadas apenas em dias úteis, após confirmação do pagamento."
            )}
          </p>
          <p>
            {t(
              "Os portes são calculados com base no peso, método de pagamento, transportadora e destino."
            )}
          </p>
        </>
      ),
    },
    {
      id: "garantias",
      title: "Avarias e Garantias",
      content: (
        <>
          <p>
            {t(
              "Todos os produtos comercializados pela Racksforall.eu beneficiam da garantia legal aplicável, nos termos da legislação portuguesa."
            )}
          </p>
          <p>
            {t(
              "Em caso de defeito ou avaria, o cliente deve contactar o Apoio ao Cliente com o número da encomenda e a descrição do problema."
            )}
          </p>
        </>
      ),
    },
    {
      id: "devolucoes",
      title: "Política de Devoluções",
      content: (
        <>
          <p>
            {t(
              "Nos primeiros 14 dias após tomar posse física dos bens, o consumidor pode devolver ou trocar o produto, de acordo com o Decreto-Lei n.º 24/2014."
            )}
          </p>
          <p>
            {t(
              "Os artigos devem ser devolvidos com embalagem, manuais, acessórios e fatura original, em estado adequado."
            )}
          </p>
          <p>
            {t(
              "Os portes de devolução ficam a cargo do consumidor nos casos de livre resolução do contrato."
            )}
          </p>

          <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-5">
            <h3 className="text-base font-semibold text-slate-900">
              {t("Como iniciar o processo")}
            </h3>
            <ul className="mt-3 space-y-2 text-slate-600">
              <li>{t("Aceder à página de Contactos")}</li>
              <li>{t("Selecionar o assunto “Devoluções”")}</li>
              <li>{t("Inserir email e referência do pedido")}</li>
              <li>{t("Descrever o motivo e submeter o formulário")}</li>
            </ul>
          </div>
        </>
      ),
    },
    {
      id: "cookies",
      title: "Política de Cookies",
      content: (
        <>
          <p>
            {t(
              "Os cookies ajudam a determinar a utilidade, interesse e número de utilizações do site, permitindo uma navegação mais rápida e eficiente."
            )}
          </p>
        </>
      ),
    },
    {
      id: "virus",
      title: "Vírus",
      content: (
        <>
          <p>
            {t(
              "A Racksforall.eu não é responsável por prejuízos decorrentes de vírus informáticos ou outras situações externas que impeçam o acesso e correto funcionamento do site."
            )}
          </p>
        </>
      ),
    },
    {
      id: "seguros",
      title: "Seguros",
      content: (
        <>
          <p>
            {t(
              "Podem estar disponíveis seguros de roubo e danos ou extensão de garantia para alguns equipamentos."
            )}
          </p>
          <p>
            {t(
              "Estes seguros estão disponíveis apenas para consumidores residentes em Portugal."
            )}
          </p>
        </>
      ),
    },
    {
      id: "legislacao",
      title: "Legislação Aplicável",
      content: (
        <>
          <p>
            {t(
              "Todas as compras efetuadas no site estão sujeitas à legislação portuguesa."
            )}
          </p>
          <p>
            {t(
              "Qualquer conflito será submetido ao tribunal português competente."
            )}
          </p>
        </>
      ),
    },
    {
      id: "litigios",
      title: "Resolução Online de Litígios",
      content: (
        <>
          <p>
            {t(
              "Em caso de litígio de consumo, o consumidor pode recorrer a entidades de resolução alternativa de litígios."
            )}
          </p>

          <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-5 text-slate-600">
            <p>
              <strong className="text-slate-900">CNIACC</strong>
            </p>
            <p>
              {t("Telefone")}: 213 847 484
            </p>
            <p>
              {t("Email")}: cniacc@uni.pt
            </p>
            <p>
              {t("Website")}: https://www.cniacc.pt/pt/
            </p>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>{t("Política de Devoluções | Racksforall")}</title>
        <meta
          name="description"
          content={t(
            "Informações sobre devoluções, trocas e reembolsos dos produtos Racksforall."
          )}
        />
        <link rel="canonical" href="https://racksforall.pt/returns-policy" />
        <meta
          property="og:title"
          content={t("Política de Devoluções | Racksforall")}
        />
        <meta
          property="og:description"
          content={t(
            "Informações sobre devoluções, trocas e reembolsos dos produtos Racksforall."
          )}
        />
        <meta property="og:url" content="https://racksforall.pt/returns-policy" />
      </Helmet>
      <main className="min-h-screen bg-stone-50 pt-24 text-slate-900 md:pt-28">
        <section className="border-b border-slate-200">
          <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <p className="text-sm font-medium uppercase tracking-[0.22em] text-slate-500">
                Racksforall.eu
              </p>
              <h1 className="mt-4 text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
                {t("Política de Trocas e Devoluções")}
              </h1>
              <p className="mt-6 text-lg leading-8 text-slate-600">
                {t(
                  "Aqui encontra a informação pré-contratual relativa a utilização do site, encomendas, garantias, devoluções e legislação aplicável."
                )}
              </p>
            </div>
          </div>
        </section>

        <section className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-12 sm:px-6 lg:grid-cols-[240px_minmax(0,1fr)] lg:px-8">
          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <p className="px-3 pb-3 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
                {t("Índice")}
              </p>

              <nav className="space-y-1">
                {sections.map((section, index) => (
                  <a
                    key={section.id}
                    href={`#${section.id}`}
                    className="group flex items-center justify-between rounded-xl px-3 py-2 text-sm text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
                  >
                    <span>{t(section.title)}</span>
                    <span className="text-xs text-slate-400 transition group-hover:text-slate-700">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </a>
                ))}
              </nav>

              <div className="mt-6 rounded-xl bg-slate-900 p-4 text-sm text-white">
                <p className="font-medium">{t("Queres tratar uma devolução?")}</p>

                <Link
                  to="/contact"
                  className="mt-3 inline-flex items-center rounded-full bg-white px-4 py-2 text-sm font-medium text-slate-900 transition hover:bg-slate-200"
                >
                  {t("Ir para Contactos")}
                </Link>
              </div>
            </div>
          </aside>

          <div className="space-y-6">
            {sections.map((section) => (
              <section
                key={section.id}
                id={section.id}
                className="scroll-mt-24 border-t border-slate-200 py-6 first:border-t-0 first:pt-0"
              >
                <div className="grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)] lg:gap-8">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
                      {t("Secção")}
                    </p>
                    <h2 className="mt-2 text-xl font-semibold text-slate-900">
                      {t(section.title)}
                    </h2>
                  </div>

                  <div className="max-w-3xl space-y-4 text-[15px] leading-7 text-slate-600">
                    {section.content}
                  </div>
                </div>
              </section>
            ))}

            <section className="border-t border-slate-200 py-6">
              <div className="grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)] lg:gap-8">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
                    {t("Apoio")}
                  </p>
                  <h2 className="mt-2 text-xl font-semibold text-slate-900">
                    {t("Falar com a equipa")}
                  </h2>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-6">
                  <p className="text-slate-600">
                    {t(
                      "Se precisares de apoio adicional sobre trocas, devoluções, garantias ou encomendas, entra em contacto connosco através da página de contactos."
                    )}
                  </p>

                  <Link
                    to="/contact"
                    className="mt-4 inline-flex items-center rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-slate-700"
                  >
                    {t("Ir para Contactos")}
                  </Link>
                </div>
              </div>
            </section>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
